import { useQuery } from "@tanstack/react-query";

import { BRAND_CACHE_KEYS } from "./keys";

import { BrandRepository } from "@/repositories/brand";

const brandRepository = new BrandRepository();

export const useGetAllBrands = () => {
  return useQuery({
    queryKey: BRAND_CACHE_KEYS.LIST,
    queryFn: async () => {
      return await brandRepository.findAll();
    },
  });
};
